import { useAuth0 } from '@auth0/auth0-react';
import { Navigate } from 'react-router-dom';
import { LogIn } from 'lucide-react';
import logoSvg from '../assets/logo.svg';
import ThemeToggle from '../components/common/ThemeToggle';

export default function LoginPage() {
  const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50 dark:bg-gray-900">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600" />
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-blue-100 dark:from-gray-900 dark:to-gray-800 relative">
      {/* Theme toggle – top-right corner */}
      <div className="absolute top-4 right-4">
        <ThemeToggle />
      </div>

      <div className="card max-w-md w-full mx-4 p-8">
        <div className="text-center mb-8">
          <img
            src={logoSvg}
            alt="FirstClose"
            className="h-10 mx-auto mb-4"
            style={{ filter: 'var(--logo-filter, none)' }}
          />
          <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">OMS Admin</h1>
          <p className="text-gray-500 dark:text-gray-400 mt-2">Order Management System Administration</p>
        </div>
        <button
          onClick={() => loginWithRedirect()}
          className="btn-primary w-full gap-2 py-3 text-base"
        >
          <LogIn className="h-5 w-5" />
          Sign in with Auth0
        </button>
        <p className="text-xs text-gray-400 dark:text-gray-500 text-center mt-6">
          Restricted access. Authorized personnel only.
        </p>
      </div>
    </div>
  );
}
